/* Typing placeholder for search inputs: types a best seller, deletes it, types the next. Data: window.CGS_TYPER (snippets/search-typer.liquid). */
(() => {
  const words = (window.CGS_TYPER || []).filter(Boolean);
  if (!words.length || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const ar = document.documentElement.lang.startsWith('ar');
  const lead = (ar ? 'ابحث عن' : 'Search') + ' '; // nbsp: flex items drop a plain trailing space

  function attach(input) {
    if (input.dataset.typer) return;
    input.dataset.typer = '1';
    const host = input.parentElement;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    const cs = getComputedStyle(input);
    const box = document.createElement('span');
    box.className = 'cgs-typer';
    box.setAttribute('aria-hidden', 'true');
    box.style.insetInlineStart = (input.offsetLeft + parseFloat(cs.paddingInlineStart)) + 'px';
    box.style.insetInlineEnd = '12px';
    box.style.top = input.offsetTop + 'px';
    box.style.height = input.offsetHeight + 'px';
    box.style.fontSize = cs.fontSize;
    box.innerHTML = `<span>${lead}</span><span class="cgs-typer__w"></span><span class="cgs-typer__c"></span>`;
    host.appendChild(box);
    input.classList.add('cgs-typer-host');
    const w = box.querySelector('.cgs-typer__w');
    const sync = () => { box.style.display = input.value ? 'none' : 'flex'; };
    ['input', 'focus', 'blur'].forEach((e) => input.addEventListener(e, sync));
    sync();

    let wi = 0, ci = 0, del = false;
    (function step() {
      const word = words[wi % words.length];
      ci += del ? -1 : 1;
      w.textContent = word.slice(0, ci);
      let wait = del ? 35 : 75;
      if (!del && ci === word.length) { del = true; wait = 1400; }
      else if (del && ci === 0) { del = false; wi++; wait = 350; }
      setTimeout(step, wait);
    })();
  }

  const scan = () => document.querySelectorAll('input[type="search"], input[name="q"]').forEach((i) => i.offsetParent && attach(i));
  scan();
  // Search modal inputs only get a size once opened.
  new MutationObserver(scan).observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open'] });
})();
